import React from "react";
import { Button, IconButton, Tooltip } from "@mui/material";
import { styled } from "@mui/material/styles";
import EditIcon from "@mui/icons-material/Edit";

// Styled components for consistent sizing in grid
const GridButton = styled(Button)(({ theme, size }) => ({
  minWidth: "auto",
  padding: size === "small" ? "4px 8px" : "6px 12px",
  fontSize: size === "small" ? "0.75rem" : "0.875rem",
  textTransform: "none",
  borderRadius: theme.spacing(0.5),
  "& .MuiButton-startIcon": {
    marginRight: size === "small" ? "4px" : "8px",
    marginLeft: 0,
  },
}));

const GridIconButton = styled(IconButton)(({ theme, size }) => ({
  padding: size === "small" ? "4px" : "8px",
  "& .MuiSvgIcon-root": {
    fontSize: size === "small" ? "1rem" : "1.25rem",
  },
}));

const GridActionButton = ({
  onClick,
  icon,
  text,
  variant = "contained",
  color = "primary",
  size = "small",
  disabled = false,
  tooltip,
  iconOnly = false,
}) => {
  const buttonProps = {
    onClick,
    disabled,
    variant,
    color,
    size,
  };

  // Icon-only button (no text)
  if (iconOnly || !text) {
    const iconButton = (
      <GridIconButton {...buttonProps} size={size}>
        {icon}
      </GridIconButton>
    );

    return tooltip ? (
      <Tooltip title={tooltip} arrow>
        {iconButton}
      </Tooltip>
    ) : (
      iconButton
    );
  }

  // Button with text and optional icon
  const button = (
    <GridButton {...buttonProps} startIcon={icon} size={size}>
      {text}
    </GridButton>
  );

  return tooltip ? (
    <Tooltip title={tooltip} arrow>
      {button}
    </Tooltip>
  ) : (
    button
  );
};

// Edit action button component
export const EditActionButton = ({
  onClick,
  disabled = false,
  tooltip = "Edit",
  iconOnly = false,
}) => (
  <GridActionButton
    icon={<EditIcon />}
    text={iconOnly ? null : "Edit"}
    onClick={onClick}
    disabled={disabled}
    tooltip={tooltip}
    color="primary"
    iconOnly={iconOnly}
  />
);

export { EditIcon };

export default GridActionButton;
